import type { TableViewType } from '@gitbook/doc-core';

import { cardsSpec } from './cards';
import { gridSpec } from './grid';
import type { TableViewSpec } from './types';

export const viewSpecs: { [type in TableViewType]: TableViewSpec<any> } = {
    grid: gridSpec,
    cards: cardsSpec,
};
